// import { useAsyncCallback } from '@affine/core/components/hooks/affine-async-hooks';
import { DocsService } from '@affine/core/modules/doc';
import {
  DocTitleUniquenessService,
  OrganizeService,
} from '@affine/core/modules/organize';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { useNavigateHelper } from '../use-navigate-helper';

export function useBlockSuiteMetaHelper() {
  const workspace = useService(WorkspaceService).workspace;
  const { openPage } = useNavigateHelper();
  const docsService = useService(DocsService);
  const docRecordList = useService(DocsService).list;
  const organizeService = useService(OrganizeService);
  const docTitleUniquenessService = useService(DocTitleUniquenessService);

  // TODO-Doma
  // "Remove" may cause ambiguity here. Consider renaming as "moveToTrash".
  const removeToTrash = useCallback(
    (docId: string) => {
      const docRecord = docRecordList.doc$(docId).value;
      if (docRecord) {
        docRecord.moveToTrash();
      }
    },
    [docRecordList]
  );

  const restoreFromTrash = useCallback(
    async (docId: string) => {
      const docRecord = docRecordList.doc$(docId).value;
      if (docRecord) {
        docRecord.restoreFromTrash();
        // yuanshi-20250807-恢复文件默认添加到originate中
        const rootNode = organizeService.folderTree.rootFolder;

        // 在添加到文件夹之前，先确保标题的唯一性
        try {
          await docTitleUniquenessService.ensureUniqueTitleInFolder(
            docId,
            rootNode
          );
        } catch (error) {
          console.error(
            'Failed to ensure title uniqueness during restore:',
            error
          );
          // 即使标题唯一性检查失败，仍然继续恢复操作
        }

        rootNode.createLink('doc', docId, rootNode.indexAt('before'));
      }
    },
    [docRecordList, organizeService, docTitleUniquenessService]
  );

  const permanentlyDeletePage = useCallback(
    (pageId: string) => {
      workspace.docCollection.removeDoc(pageId);
    },
    [workspace]
  );

  const duplicate = useCallback(
    async (
      pageId: string,
      openPageAfterDuplication: boolean = true
    ): Promise<string> => {
      const newPageId = await docsService.duplicate(pageId);
      openPageAfterDuplication &&
        openPage(workspace.docCollection.id, newPageId);

      return newPageId;
    },
    [docsService, openPage, workspace.docCollection.id]
  );

  return {
    removeToTrash,
    restoreFromTrash,
    permanentlyDeletePage,

    duplicate,
  };
}
